// src/layouts/AppLayout.jsx
import { useState } from "react";
import { Outlet } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Sidebar from "../ui/Sidebar";
import Topbar from "../ui/Topbar";

export default function AppLayout({ children }) {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();
  const isFlowEditor = location.pathname.startsWith("/flow-3");

  return (
    <div className="h-screen bg-neutral-900 text-neutral-100 overflow-hidden flex flex-col">
      <Topbar onToggleSidebar={() => setCollapsed(c => !c)} />
      <div className="flex flex-1 min-h-0">
        <Sidebar collapsed={collapsed} />
        <main className="flex-1 min-w-0 overflow-hidden">
          <div className={isFlowEditor ? "h-full min-h-0 p-0" : "h-full overflow-auto p-6"}>
            <Outlet />
          </div>                
        </main>
      </div>
    </div>
  );
}
